export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9407.447cfff4.jpg";